import { useState } from "react";
import { Wand2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { useJob } from "../../hooks/useJob";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";

export function ScriptDialog({ book, onDone }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [pages, setPages] = useState(4);
  const [job, start, busy] = useJob((j) => { toast.success(`${j.pages_made} pages scripted${j.new_characters ? ` · ${j.new_characters} new characters added` : ""}`); setOpen(false); setText(""); onDone(); });
  const go = async () => { try { const { data } = await api.post(`/books/${book.id}/comic/script`, { text, pages: Number(pages) || 4 }); start(data.id); } catch (e) { if (!e.cancelled) toast.error(errMsg(e)); } };
  return (
    <>
      <Button size="sm" variant="outline" className="border-amber-500/40" onClick={() => setOpen(true)} data-testid="comic-script-open"><Wand2 size={13} className="mr-1" />Script from story</Button>
      <Dialog open={open} onOpenChange={(o) => !busy && setOpen(o)}>
        <DialogContent className="bg-slate-950 border-slate-800 max-w-2xl" data-testid="comic-script-dialog">
          <DialogHeader><DialogTitle className="font-display">Turn your story into panels</DialogTitle>
            <DialogDescription className="text-slate-400">Paste a scene or outline. The AI breaks it into pages, panel descriptions and balloons — your plot, names and lines stay yours. New pages are added to the end, and you can edit everything.</DialogDescription></DialogHeader>
          <Textarea value={text} onChange={(e) => setText(e.target.value)} maxLength={20000} placeholder="Paste your story, scene or outline (at least 40 characters)" className="min-h-[220px] text-sm" data-testid="comic-script-text" />
          <div className="flex items-center gap-3">
            <label className="text-xs text-slate-400 flex items-center gap-2">Pages<Input type="number" min="1" max="24" value={pages} onChange={(e) => setPages(e.target.value)} className="h-8 w-20" data-testid="comic-script-pages" /></label>
            <Button onClick={go} disabled={busy || text.trim().length < 40} className="ml-auto bg-amber-600 hover:bg-amber-500" data-testid="comic-script-run">{busy ? `Scripting… ${job?.progress || 0}%` : "Create script"}</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
